import { useMutation, useQueryClient } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { sms_api } from '@axo/shared/data-access/api';
import { SMSCommunicationKeys } from '../../cache-keys/SMSCommunicationKeys.tsx';

export function useCreateCommunicationSMS(customerPhoneNumber: string) {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(sms_api.createSMS(api), {
    onSuccess: () => {
      return client.invalidateQueries(
        SMSCommunicationKeys.root({ customerPhoneNumber })
      );
    },
  });
}
